import FamilyTreePdfCard from "../components/FamilyTree/PdfCard";
import { framilyTreeData } from "../data";

function Vanshavali() {
  return (
    <div className="container py-3 py-lg-5">
      <h1 className="h3 mb-4">Vanshavali</h1>
      <div className="row g-4 align-items-stretch">
        <div className="col-12 col-lg-4 d-flex vanshavali-cta-col">
          <div className="card border-0 shadow-sm w-100 vanshavali-form-cta">
            <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-4">
              <div className="vanshavali-form-cta-icon mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="9" y1="13" x2="15" y2="13" />
                  <line x1="9" y1="17" x2="13" y2="17" />
                </svg>
              </div>
              <h5 className="card-title fw-bold mb-2">
                વંશાવલીમાં નવા - ફેરફાર માટેનું ફોર્મ
              </h5>
              <ul className="card-text small text-start mb-4 ps-3 fw-semibold">
                <li>
                  "વંશાવલી" 2019 પીડીએફ ફોર્મેટ માં આપના કુટુંબ અંગેની માહિતી
                  જોઈ શકશો
                </li>
                <li>
                  આ વંશાવલી માં ફક્ત છ ગામ ચરોતર પાટીદાર સમાજના વ્યક્તિઓ જ નામનો
                  સુધારો અથવા ઉમેરો કરાવી શકશે
                </li>
                <li>
                  આ અંગેનું "વંશાવલી ફોર્મ" ભરવું ફરજિયાત છે — આ ફોર્મ ઓનલાઈન
                  ભરવું
                </li>
                <li>
                  આ માટે "વંશાવલી" માં દર્શાવેલ ગામ તથા પેજ નંબર અવશ્ય લખવો
                </li>
                <li>
                  નવા નામનું ફોર્મ વંશાવલીમાં ઘટકો દ્વારા મંજૂર થયા પછી જ ઉમેરો
                  કરવામાં આવશે
                </li>
                <li>
                  આ વંશાવલીમાં નવું તથા સુધારા દર ચાર મહિને જે તે સુધારા કરીને
                  ફરીથી અપલોડ કરવામાં આવશે
                </li>
              </ul>
              <a
                href="/vanshavali/form"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary px-4"
              >
                Open Form
              </a>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-8">
          <div className="vanshavali-pdf-grid h-100">
            {framilyTreeData.map((item, i) => {
              const base = item.pdf?.toLowerCase().endsWith(".pdf")
                ? item.pdf.slice(0, -4)
                : item.pdf;
              const title =
                item.title ||
                (base ? base.charAt(0).toUpperCase() + base.slice(1) : "PDF");
              return <FamilyTreePdfCard key={i} title={title} pdf={item.pdf} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vanshavali;
